import en from './en-GB/en'
import de from './de-DE/de'
import fr from './fr-FR/fr'

export const languages = {
  en: {
    ...en,
    $vuetify: en
  },
  de: {
    ...de,
    $vuetify: de
    
  },
  fr: {
    ...fr,
    $vuetify: fr
  }
}



// WEBPACK FOOTER //
// ./src/i18n/index.js